import { fork } from 'redux-saga/effects';
import { watchFetchClassApps, watchFetchClassesList } from './category';
import {
  watchAppDetails,
  watchAppRecommend,
  watchFetchGroupContent,
  watchFetchDetailGiftList,
  watchFetchReceiveGift,
  watchFetchAppForumRelated,
} from './detail';
import { watchLogging, watchPostLogInfo } from './log';
import {
  watchFetchLocalMachineInfo,
  watchFetchLocalSofts,
  watchRequestNativeInstall,
  watchRequestNativeUninstall,
  watchRequestNativeInstallList,
  watchFetchSilentSoft,
} from './native';
import { watchFetchNetBeat } from './network';
import {
  watchFetchRecoBanner,
  watchFetchRecoRecommend,
  watchBannerContent,
  watchWeekHotContent,
  watchRecommendContent,
  watchGroupContent,
  watchGuessLike,
  watchSoftInfos,
} from './recommend';
import {
  watchFetchLenovoWords,
  watchFetchSearchResult,
  watchFetchSearchRecommend,
  watchFetchCleanSearchRecommend,
  watchFetchFeedbackSuggest,
  watchFetchHotSearchBox,
} from './search';
import { watchOtherRankApps, watchRankApps, watchAllRanksAndApps } from './topn';
import { watchFetchWelcomeIdDetail } from './welcomeids';
import { watchFetchGetCustomeSelectPopStatus, watchFetchGetWelcomApp } from './welcomePopUp';

// 安卓分类
import { watchFetchAClassApps, watchFetchAClassesList } from './acategory';
import {
  watchAAppDetails,
  watchAAppRecommend,
  watchFetchAGroupContent,
  watchFetchADetailGiftList,
  watchFetchAReceiveGift,
} from './adetail';
import {
  watchFetchInstallAndroidSoft,
  watchFetchInstallAndroidSoftList,
  watchFetchRunAndroidSoft,
} from './anative';
import {
  watchFetchGetSIMIsVTEabled,
  watchFetchGetIsSIMRunning,
  watchFetchGetIsSIMInstalled,
} from './asimstatus';
import {
  watchFetchABanner,
  watchFetchARecommendSoft,
  watchFetchAGroupSoft,
  watchFetchAGroupSoftMore,
} from './arecommend';
import {
  watchFetchGetCommentList,
  watchFetchGetGrade,
  watchFetchAddComment,
  watchFetchAddZan,
  watchFetchAddScoreForStore,
} from './comment';
import {
  watchSpecialInfo,
  watchlFetchSpeciaAppDetails,
  watchFetchSpecialListTags,
  watchFetchSpecialListList,
  watchFetchSpecialListBySource,
  watchFetchResetSpecialInfo,
  watchFetchSetSpecialZan,
} from './special';
import {
  watchFetchWPCategoryLabels,
  watchFetchWPCategoryImgList,
  watchFetchWPDetailBanner,
  watchFetchWPBannerList,
  watchFetchWPRecommendList,
  watchFetchWPRankList,
  watchFetchWPRecoBanner,
  watchFetchWPRecoGroup,
  watchFetchWPCollectList,
  watchFetchWPSetupList,
  watchFetchWpOption,
  watchFetchWpScreenListn,
  watchFetchWPAuthorList,
  watchFetchWPAuthorDetail,
  watchFetchWPAuthorShowreel,
} from './wallpaper';

import {
  watchFetchCategoryList,
  watchFetchSoftsDetail,
  watchStopScanResidual,
  watchAddTempResidual,
  watchStopDeleteResidual,
  watchFetchResidualSoftsDetail,
} from './uninstall';

import { watchFetchGetWelcomData, watchFetchRecentPopupStrategy } from './welcome';

import { watchGameScrollSave, watchGameScrollUse } from './game';

// 用户反馈

import { watchFetchFeedbackRecords, watchFetchFeedbackQuestionTypes } from './userFeedback';

// v7.0 卡片

import { watchFetchVideoContent } from './card';

// v7.1教育

import {
  watchEducationRecommendBanner,
  watchEducationRecommendGroups,
  watchEducationCategoryTags,
  watchEducationCategoryGradelist,
  watchEducationMineGradelist,
  watchEducationMineGradeDelete,
  watchEducationDetail,
  watchEducationPlayUrl,
  watchEducationPlayDataReport,
  watchEducationCollectReport,
  watchEducationPay,
  watchEducationPayResult,
} from './education';

// v7.2我的收藏
import {
  watchFetchSoftCollectList,
  watchFetchAddCollectSpecialorSoft,
  watchFetchDeleteCollectSpecialorSoft,
  watchFetchSpecialCollectList,
} from './collection';

// v7.2 论坛
import {
  watchForumList,
  watchForumListPub,
  watchForumListCol,
  watchForumLenovoSoft,
  watchForumDetail,
  watchForumDetailMore,
  watchForumAddComment,
  watchForumAddReview,
  watchForumCommentList,
  watchForumCommentZan,
  watchForumActionSet,
  watchForumActionRemove,
  watchForumDelete,
} from './forum';

import {
  watchFetchMessageHot,
  watchFetchDeleteMessageHot,
  watchFetchMessageList,
  watchMessageZan,
} from './message';

export default function* rootSaga() {
  yield fork(watchFetchLocalMachineInfo);
  yield fork(watchFetchLenovoWords);
  yield fork(watchFetchLocalSofts);

  yield fork(watchFetchSearchResult);
  yield fork(watchFetchSearchRecommend);
  yield fork(watchFetchCleanSearchRecommend);

  yield fork(watchRequestNativeInstall);
  yield fork(watchRequestNativeUninstall);
  yield fork(watchRequestNativeInstallList);
  yield fork(watchFetchSilentSoft);
  yield fork(watchFetchGetWelcomApp);
  yield fork(watchFetchGetCustomeSelectPopStatus);

  yield fork(watchFetchRecoBanner);
  yield fork(watchFetchRecoRecommend);
  yield fork(watchBannerContent);
  yield fork(watchWeekHotContent);
  yield fork(watchRecommendContent);
  yield fork(watchGroupContent);
  yield fork(watchGuessLike);
  yield fork(watchSoftInfos);

  yield fork(watchOtherRankApps);
  yield fork(watchRankApps);
  yield fork(watchAllRanksAndApps);

  yield fork(watchFetchClassApps);
  yield fork(watchFetchClassesList);

  yield fork(watchAppDetails);
  yield fork(watchAppRecommend);

  yield fork(watchFetchNetBeat);

  yield fork(watchFetchWelcomeIdDetail);

  yield fork(watchLogging);
  yield fork(watchPostLogInfo);

  // 安卓 saga监听
  yield fork(watchFetchAClassApps);
  yield fork(watchFetchAClassesList);

  yield fork(watchAAppDetails);
  yield fork(watchAAppRecommend);

  yield fork(watchFetchInstallAndroidSoft);
  yield fork(watchFetchInstallAndroidSoftList);
  yield fork(watchFetchRunAndroidSoft);

  yield fork(watchFetchGetSIMIsVTEabled);
  yield fork(watchFetchGetIsSIMRunning);
  yield fork(watchFetchGetIsSIMInstalled);

  yield fork(watchFetchABanner);
  yield fork(watchFetchARecommendSoft);
  yield fork(watchFetchAGroupSoft);
  yield fork(watchFetchAGroupSoftMore);

  yield fork(watchFetchGetCommentList);
  yield fork(watchFetchGetGrade);
  yield fork(watchFetchAddComment);
  yield fork(watchFetchAddZan);
  yield fork(watchFetchAddScoreForStore);

  yield fork(watchSpecialInfo);
  yield fork(watchlFetchSpeciaAppDetails);
  yield fork(watchFetchGroupContent);
  yield fork(watchFetchDetailGiftList);
  yield fork(watchFetchReceiveGift);

  yield fork(watchFetchAGroupContent);
  yield fork(watchFetchADetailGiftList);
  yield fork(watchFetchAReceiveGift);

  // 壁纸监听
  yield fork(watchFetchWPDetailBanner);
  yield fork(watchFetchWPRankList);
  yield fork(watchFetchWPRecoBanner);
  yield fork(watchFetchWPRecoGroup);
  yield fork(watchFetchWPBannerList);
  yield fork(watchFetchWPRecommendList);
  yield fork(watchFetchWPCategoryLabels);
  yield fork(watchFetchWPCategoryImgList);
  yield fork(watchFetchWPCollectList);
  yield fork(watchFetchWPSetupList);
  yield fork(watchFetchWpOption);
  yield fork(watchFetchWpScreenListn);
  yield fork(watchFetchWPAuthorList);
  yield fork(watchFetchWPAuthorDetail);
  yield fork(watchFetchWPAuthorShowreel);

  // 我的软件
  yield fork(watchFetchCategoryList);
  yield fork(watchFetchSoftsDetail);
  // 专题 列表页面
  yield fork(watchFetchSpecialListTags);
  yield fork(watchFetchSpecialListList);
  yield fork(watchFetchSpecialListBySource);
  yield fork(watchFetchResetSpecialInfo);

  yield fork(watchStopScanResidual);
  yield fork(watchAddTempResidual);
  yield fork(watchStopDeleteResidual);
  yield fork(watchFetchResidualSoftsDetail);

  // 搜索反馈
  yield fork(watchFetchFeedbackSuggest);

  // 欢迎页
  yield fork(watchFetchGetWelcomData);
  yield fork(watchFetchRecentPopupStrategy);

  // 游戏页
  yield fork(watchGameScrollSave);
  yield fork(watchGameScrollUse);

  // 用户反馈
  yield fork(watchFetchFeedbackRecords);
  yield fork(watchFetchFeedbackQuestionTypes);
  yield fork(watchFetchSetSpecialZan);

  // v7.0 卡片

  yield fork(watchFetchVideoContent);

  // v7.1 教育
  yield fork(watchEducationRecommendBanner);
  yield fork(watchEducationRecommendGroups);
  yield fork(watchEducationCategoryTags);
  yield fork(watchEducationCategoryGradelist);
  yield fork(watchEducationMineGradelist);
  yield fork(watchEducationMineGradeDelete);
  yield fork(watchEducationDetail);
  yield fork(watchEducationPlayUrl);
  yield fork(watchEducationPlayDataReport);
  yield fork(watchEducationCollectReport);
  yield fork(watchEducationPay);
  yield fork(watchEducationPayResult);

  // v7.2 我的收藏
  yield fork(watchFetchSoftCollectList);
  yield fork(watchFetchAddCollectSpecialorSoft);
  yield fork(watchFetchDeleteCollectSpecialorSoft);
  yield fork(watchFetchSpecialCollectList);

  // v7.2 论坛
  yield fork(watchForumList);
  yield fork(watchForumListPub);
  yield fork(watchForumListCol);
  yield fork(watchForumLenovoSoft);
  yield fork(watchForumDetail);
  yield fork(watchForumDetailMore);
  yield fork(watchForumAddComment);
  yield fork(watchForumAddReview);
  yield fork(watchForumCommentList);
  yield fork(watchForumCommentZan);
  yield fork(watchForumActionSet);
  yield fork(watchForumActionRemove);
  yield fork(watchForumDelete);

  // v7.4
  yield fork(watchFetchHotSearchBox);
  yield fork(watchFetchAppForumRelated);
  yield fork(watchFetchMessageHot);
  yield fork(watchFetchDeleteMessageHot);
  yield fork(watchFetchMessageList);
  yield fork(watchMessageZan);
}
